var map = {
	"./app-icon.svg": 1729,
	"./caret-right-icon.svg": 1730,
	"./chrome-icon.webp": 1731,
	"./edge-icon.webp": 1732,
	"./firefox-icon.webp": 1733,
	"./opera-icon.webp": 1734,
	"./safari-icon.webp": 1735,
	"./unknown-icon.webp": 1736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1728;